/**
* @ngdoc directive
* @name On Blur
*
* @description
  Callback on item blur
  Used for inline edit to save item on blur
*
*/

app.directive('onBlur', ["$document", function($document) {
  return {
    link: function($scope, $element, $attributes) {
      var scopeExpression = $attributes.onBlur,
          onDocumentClick = function(event) {
            var isChild = $element.find(event.target).length > 0;
            var isPopUpOpen = angular.element('.modal-dialog').is(':visible');
            var isCalendarOpen = angular.element('.datepicker').length > 0;
            var isDateRangePickerOpen = angular.element('.daterangepicker').is(':visible');
            var isClickedOnAutocomplete = angular.element(event.target).parents('.autocomplete').length;
            var isClickedOnTag = angular.element(event.target).parents('.tag-item').length;
            var closeNotAllowed = angular.element(event.target).parents('.disallow-close').length ||
               angular.element(event.target).hasClass('disallow-close');

            if (isChild || isPopUpOpen || isCalendarOpen || closeNotAllowed || isClickedOnAutocomplete || isClickedOnTag || isDateRangePickerOpen) {
              return;
            } else {
              $scope.$apply(scopeExpression);
            }
          };

      $document.on('click', onDocumentClick);

      $element.on('$destroy', function() {
        $document.off('click', onDocumentClick);
      });
    }
  };
}]);



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/onBlurDirective.js